import * as Yup from 'yup'

const LoginSchema = Yup.object().shape({
  email: Yup.string().email('Deve ser um e-mail válido').required('Campo obrigatório'),
  password: Yup.string().min(8, 'Deve conter no mínimo 8 caracteres').required('Campo obrigatório'),
  keepAlive: Yup.string().nullable(),  
})

export default LoginSchema